import {IRegionStats} from "../../offer/list/actions/offer_list_selected_data_actions";
import {OfferType} from "../../offer/types/OfferType";

export const getLowestPriceForOfferType = (stats: IRegionStats | null | undefined, offerType: OfferType | undefined): number | null => {
    if (!stats) {
        return null;
    }

    let price: number | undefined;

    switch (offerType) {
        case OfferType.FLAT:
            price = stats.properties_flats_ranges_price_min;
            break;
        case OfferType.HOUSE:
            price = stats.properties_houses_ranges_price_min;
            break;
        case OfferType.COMMERCIAL:
            price = stats.properties_commercials_ranges_price_min;
            break;
        default: {
            const candidates = [stats.properties_flats_ranges_price_min, stats.properties_houses_ranges_price_min].filter((p): p is number => !!p && p > 0);

            return candidates.length > 0 ? Math.min(...candidates) : null;
        }
    }

    return price && price > 0 ? price : null;
};
